import { fallbackLng } from '@jackedlogs/i18n';

// Locale-aware short-date formatting. Hermes ships full Intl on RN
// 0.85 (Android), so DateTimeFormat is available across every API
// level we target. The Intl.DateTimeFormat constructor is non-trivial
// to instantiate (loads ICU data + resolves the format), so we cache
// per-locale and reuse.

const cache = new Map<string, Intl.DateTimeFormat>();

const buildFormatter = (locale: string): Intl.DateTimeFormat => {
  try {
    return new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  } catch {
    return new Intl.DateTimeFormat(fallbackLng, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }
};

const getFormatter = (locale: string): Intl.DateTimeFormat => {
  let f = cache.get(locale);
  if (!f) {
    f = buildFormatter(locale);
    cache.set(locale, f);
  }
  return f;
};

export function formatShortDate(iso: string, locale: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return getFormatter(locale).format(d);
}
